exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-table-list .col-status.disable[data-v-7f5500f3]{color:#e6a23c}.table-pagination[data-v-7f5500f3]{margin-top:0;padding:10px 20px}.table-pagination.fixed[data-v-7f5500f3]{padding:5px 20px;position:fixed;left:0;right:0;bottom:0;z-index:1002}", ""]);

// exports
